module.exports = "/_next/static/media/93c439b2722c17fead21035a5a96e3cb.svg";